export const id = {
  title: 'Potensi Kecepatan Angin',
  subtitle: '1 km, global, DTU/Grup Bank Dunia/ESMAP',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Fungsi',
      value: 'Kecepatan angin rata-rata untuk lokasi mana pun di Bumi',
    },
    {
      label: 'Resolusi',
      value: '1 km',
    },
    {
      label: 'Cakupan geografis',
      value: 'Global',
    },
    {
      label: 'Sumber',
      value: '\tDTU/Kelompok Bank Dunia/ESMAP',
    },
    {
      label: 'Frekuensi pembaruan',
      value: '',
    },
    {
      label: 'Tanggal konten',
      value: '',
    },
    {
      label: 'Peringatan',
      value:
        'GWA menggunakan dua komponen pemodelan utama yang dapat memasukkan ketidakpastian ke dalam perhitungan. Komponen-komponen ini adalah pemodelan skala mesoskala dan pemodelan skala mikro.',
    },
    {
      label: 'Lisensi',
      value: '[CC 4.0](https://creativecommons.org/licenses/by/4.0/)',
    },
  ],
  overview: {
    label: 'Ikhtisar',
    value:
      'Kumpulan data kecepatan angin rata-rata Global Wind Atlas (GWA) dibuat oleh Departemen Energi Angin di Universitas Teknik Denmark (DTU), Grup Bank Dunia, dan Program Bantuan Manajemen Sektor Energi (ESMAP).\n\nKecepatan angin rata-rata adalah salah satu indikator kinerja utama produksi energi angin. GWA dimulai dengan data kecepatan angin beresolusi rendah dan mengubahnya menjadi data resolusi tinggi menggunakan proses perampingan. Hasil dari proses ini adalah model iklim angin lokal di seluruh dunia (kecuali Kutub Utara dan Selatan dan wilayah laut lepas pantai yang jauh) pada resolusi 1 kilometer untuk tiga ketinggian: 50 meter, 100 meter dan 200 meter.',
  },
  citation: {
    label: 'Rujukan',
    value:
      'Data/information/map obtained from the Global Wind Atlas 2.0, a free, web-based application developed, owned and operated by the Technical University of Denmark (DTU) in partnership with the World Bank Group, utilizing data provided by Vortex, with funding provided by the Energy Sector Management Assistance Program (ESMAP). For additional information: https://globalwindatlas.info. Accessed through Resource Watch, (date)',
  },
};
